module.exports = __webpack_public_path__ + "media/images/ai_brain_topics/wrong_item-5461dd177e259280764a748d6463d2c3.png";